import "../../../../src/styles/rbg-code.css";
import RbgCodeBlock from "../../../../src/pages/code-blocks/remove-background-code-block.md";
import GenMask from "../../../../src/pages/code-blocks/generate-mask-code-block.md";
import * as React from 'react';
export default {
  RbgCodeBlock,
  GenMask,
  React
};